import { render, staticRenderFns } from "./KsSelect.vue?vue&type=template&id=31594cb4"
import script from "./KsSelect.vue?vue&type=script&lang=js"
export * from "./KsSelect.vue?vue&type=script&lang=js"
import style0 from "./KsSelect.vue?vue&type=style&index=0&id=31594cb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports